module.exports = __webpack_public_path__ + "img/bgd16.3ba32866.svg";